export const createManifoldAggregate = (manifold) => {
  const mergeTank = {}
  mergeTank.tank_ids = manifold.tanks.map((tank) => tank.tank_id)
  mergeTank.store_number = manifold.tanks[0]?.store_number
  mergeTank.current_volume = manifold.tanks.map((item) => item.current_volume).reduce((prev, next) => prev + next)
  mergeTank.projected_volume =
    manifold.tanks.some((item) => !!item.projected_volume) &&
    manifold.tanks
      .filter((item) => !!item.projected_volume)
      .map((item) => item.projected_volume)
      .reduce((prev, next) => prev + next)
  mergeTank.model_target_min = manifold.tanks.map((item) => item.model_target_min).reduce((prev, next) => prev + next)
  mergeTank.model_target_max = manifold.tanks.map((item) => item.model_target_max).reduce((prev, next) => prev + next)
  mergeTank.tank_size = manifold.tanks.map((item) => item.tank_size).reduce((prev, next) => prev + next)
  mergeTank.storage_max = manifold.tanks.map((item) => item.storage_max).reduce((prev, next) => prev + next)
  mergeTank.run_out_date = manifold.run_out_date
  mergeTank.run_out_date_with_drops = manifold.run_out_date_with_drops
  mergeTank.percent_filled = mergeTank.current_volume / mergeTank.storage_max
  mergeTank.projected_percent_filled = mergeTank.projected_volume / mergeTank.storage_max
  mergeTank.manifold_id = manifold.manifold_id
  mergeTank.ici = manifold.ici
  return mergeTank
}

export const getWeekday = (num) => {
  switch (num) {
    case 0:
      return 'Sun'
      break
    case 1:
      return 'Mon'
      break
    case 2:
      return 'Tue'
      break
    case 3:
      return 'Wed'
      break
    case 4:
      return 'Thu'
      break
    case 5:
      return 'Fri'
      break
    case 6:
      return 'Sat'
      break
    default:
      return ''
  }
}

export function getTankSelected(selectedTank, selectedManifold, tank) {
  return (
    (tank.tank_id === selectedTank?.tank_id && tank.store_number === selectedTank?.store_number) ||
    selectedManifold?.manifold_id === tank.manifold_id
  )
}
